import { GetUserByIdMeta, GetUserByIdPayload } from 'types/store/GetUserById';
import { createAsyncReducer } from 'utils/Redux';

import { getUserByIdActions } from '../actions';

export default createAsyncReducer<GetUserByIdMeta, GetUserByIdPayload>(
  getUserByIdActions
);
